import { render, staticRenderFns } from "./candidate-card.vue?vue&type=template&id=3db2319e&"
import script from "./candidate-card.vue?vue&type=script&lang=js&"
export * from "./candidate-card.vue?vue&type=script&lang=js&"
import style0 from "@/styles/candidate/candidate-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VCardText,VLazy})
